import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DeleteWarningIcon } from '../ui/icons';
import { useDeleteModal } from './useDeleteModal';
import { DefaultTopLevelGroup } from '../../common/constants';

const DeleteModal = ({ groupOrgId, groupDisplayName }: { groupOrgId: string, groupDisplayName: string }) => {
  const { setGroupOrgId, handleDeleteButtonClick, showModel, setShowModel } = useDeleteModal();
  const handleClose = () => setShowModel(false);
  const handleShow = () => {
    setShowModel(true);
    setGroupOrgId(groupOrgId);
  };
  const isParentGroup: boolean = DefaultTopLevelGroup.ID == groupOrgId;

  return (
    <>
      <div className= {isParentGroup ? 'disabled-item' : ''} onClick={handleShow}>
        Delete
      </div>

      <Modal show={showModel} onHide={handleClose} className='modal-container' centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className='delete-heading'>
              <DeleteWarningIcon></DeleteWarningIcon>
              <h1>Delete</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete {groupDisplayName}?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn-delete' onClick={handleDeleteButtonClick}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteModal;